import * as Constants from "../constants";
import * as InitialStates from "../constants/initialStates";

export default function courseReducer(state = InitialStates.getInitialCourseState(), action) {
  switch (action?.type) {
    case Constants.GET_COURSE:
      return { ...InitialStates.getInitialCourseState(), loading: true };
    case Constants.GET_COURSE_SUCCESS: {
      const data = action.payload;
      return {
        ...InitialStates.getInitialCourseState(),
        course: {
          id: data?.id,
          teacher: data?.teacher,
          livePlaceholder: data?.livePlaceholder?.url || data.livePlaceholder?.defaultUrl,
          numberOfStudents: data?.numberOfStudents,
          openGraphCover: data?.openGraphCover,
          title: data?.title,
          relationships: data?.relationships,
        },
      };
    }
    case Constants.GET_COURSE_ERROR: {
      return {
        ...InitialStates.getInitialCourseState(),
        errorFetching: true,
      };
    }
    default:
      return state;
  }
}
